module.exports = __webpack_public_path__ + "img/dxzz.97428aa3.jpg";